import React from "react";
import { FrontColors } from "../../../models/FrontColors";
import { FrontSpacing } from "../../../models/FrontSpacing";
import { Flex } from "../../BuildingBlocks/Flex";
import { MaxWidth } from "../../BuildingBlocks/MaxWidth";
import { SpacingColumn } from "../../BuildingBlocks/SpacingColumn";
import { FPLandingTitle } from "../Simple/FPLandingTitle/FPLandingTitle";
import { FPSimpleLogo } from "../Simple/FPSimpleLogo/FPSimpleLogo";
import { TPublicPropertyReportCreateForm } from "../../../../../domain/codecs/form/PublicPropertyReportForm";
import { LandRegistryOfficialCopyWithSummaryResponseSuccess } from "../../../../../domain/codecs/LandRegistry";
import { FPPropertyReportResultsSuccess } from "./FPPropertyReportResultsSuccess";
import { FPError } from "../Complex/FPError/FPError";
import { FontQuicksand } from "../../BuildingBlocks/FontQuicksand";
import { FontSize } from "../../BuildingBlocks/FontSize";
import { TextAlign } from "../../BuildingBlocks/TextAlign";
import { TextColor } from "../../BuildingBlocks/TextColor";
import { WeightSemiBold } from "../../WeightSemiBold/WeightSemiBold";
import { FPPropertyReportSubmitting } from "./FPPropertyReportSubmitting";
import { FPPropertyReportValuationBooked } from "./FPPropertyReportValuationBooked";
import { propertyReportErrorMessages } from "./propertyReportErrorMessages";

export const FPPropertyReportResults = (props: {
    form: TPublicPropertyReportCreateForm,
}): JSX.Element => {
    const isSuccess = props.form.children.response?._tag === "success";

    const isValuationOnly = props.form.children.is_valuation_only;

    const isSubmitting = props.form.status === "submitting";

    const errorMessages = propertyReportErrorMessages(props.form);

    const isError = errorMessages.length > 0;

    if (isValuationOnly && !isSubmitting && !isError) {
        return <FPPropertyReportValuationBooked />;
    }

    const successData =
        props.form.children.response?._tag === "success"
            ? props.form.children.response
            : LandRegistryOfficialCopyWithSummaryResponseSuccess.newDefault();

    const address = (
        props.form.children.response?._tag === "success"
            ? props.form.children.response.address || ""
            : ""
    ).toUpperCase();

    return <SpacingColumn
        spacing={FrontSpacing.LARGE_1}
        justifyContent="center"
    >
        {/* LOGO */}
        <Flex justifyContent="center">
            <FPSimpleLogo width="95px" />
        </Flex>

        {/* HEADER */}
        <Flex justifyContent="center">
            <MaxWidth width="530px">
                <FPLandingTitle
                    size={60}
                    color={FrontColors.NEUTRAL_18}
                    align="center"
                >
                    {/* While submitting we do not yet know whether a register was bought, so
                        promising a report here is wrong for every introducer whose Land
                        Registry toggle is off - which is all of them by default. */}
                    {isSubmitting ? "One moment." : "Your Report."}
                </FPLandingTitle>
            </MaxWidth>
        </Flex>

        {/* ADDRESS */}
        <Flex justifyContent="center">
            <MaxWidth width="530px">
                <Flex justifyContent="center">
                    <MaxWidth width="425px">
                        <TextColor color={FrontColors.NEUTRAL_18}>
                            <TextAlign position="center">
                                <FontQuicksand>
                                    <FontSize
                                        size={20}
                                        lineHeight={1.2}
                                    >
                                        <WeightSemiBold>
                                            {address}
                                        </WeightSemiBold>
                                    </FontSize>
                                </FontQuicksand>
                            </TextAlign>
                        </TextColor>
                    </MaxWidth>
                </Flex>
            </MaxWidth>
        </Flex>

        <Flex justifyContent="center">
            {/* SUBMITTING - PLACEHOLDER */}
            {isSubmitting &&
                <FPPropertyReportSubmitting />
            }

            {/* SUCCESS - SHOW RESULTS */}
            {isSuccess &&
                <FPPropertyReportResultsSuccess
                    deceasedName={props.form.edited.deceased_name}
                    data={successData}
                    titleRegisterUrl={props.form.children.title_register_url}
                    transactionType={props.form.edited.transaction_type || "unknown"}
                    quotes={props.form.children.quotes}
                />
            }

            {/* ERROR */}
            {isError &&
                <FPError
                    errorMessages={errorMessages}
                />
            }
        </Flex>
    </SpacingColumn>;
};
